import React from 'react';
import {bindActionCreators} from 'redux';
import {FmlxIcon, FmlxButton} from 'fmlx-common-ui';
import {connect, useDispatch, useSelector} from 'react-redux';
import PropTypes from 'prop-types';
import {checkLoadCellError} from 'stores/business/loadCellErrorBusiness';
import {CurrentStateEnum, TrayType} from 'constants/dataEnum';
import {getWizardInitialTrayType} from 'stores/selectors/wizardSelectors';
import withIntl from '../../../lib/withIntl';
import '../SetupWizard.scss';
import {setCurrentStepData} from '../../../stores/actions/wizardStateAction';
import {getSetupWizardBodyFormat} from '../../../stores/business/setupWizardBusiness/commonSetupWizardBusiness';
import SetupWizardTitleHeader from '../components/SetupWizardTitleHeader';
import FormattedHTMLMessage from '../../../components/FormattedHTMLMessage';
import SetupWizardImage from '../SetupWizardImage';
import {showIsBusyModal, showModalUnsupportedTray} from '../../../stores/business/commonModalBusiness';
import {getInstrumentStatus, isTrayInstalled} from '../../../stores/business/instrumentBusiness';
import {checkTraySuitabilitySetupWizard} from '../../../stores/business/setupWizardBusiness/setupWizardInstrumentBusiness';

const mapStateToProps = (state) => ({
  trayType: state.trayCalibrationState.trayType,
});

const mapDispatchToProps = (dispatch) => ({
  setupWizardBusinessSaveViewData: bindActionCreators(setCurrentStepData, dispatch),
  commonSetupWizardBusinessGetBodyFormat: bindActionCreators(getSetupWizardBodyFormat, dispatch),
  commonModalBusinessShowModalUnsupportedTray: bindActionCreators(showModalUnsupportedTray, dispatch),
  instrumentBusinessIsTrayInstalled: bindActionCreators(isTrayInstalled, dispatch),
});

function SetupWizardGeneralStepPage({
  showInfo,
  onButtonClick,
  titleIntlId,
  buttonProps,
  withTitleAndBodyText,
  withImage,
  withImageCaption,
  commonSetupWizardBusinessGetBodyFormat,
  // instrumentBusinessIsTrayInstalled
}) {
  const dispatch = useDispatch();
  const trayType = useSelector(getWizardInitialTrayType);
  const isHVTrayInstalled = trayType === TrayType.HIGH_VOLUME_CADDY;

  const {classNameFormat, intlTextFormat, currentSubstep, stepName} = commonSetupWizardBusinessGetBodyFormat();

  const handleButtonClick = async () => {
    const instrumentStatus = await dispatch(getInstrumentStatus());
    if (instrumentStatus?.currentState !== CurrentStateEnum.IDLE) {
      dispatch(showIsBusyModal());
      return;
    }

    const isLoadCellError = await dispatch(checkLoadCellError(null, handleButtonClick));
    if (isLoadCellError) return;
    const isSuitable = await dispatch(checkTraySuitabilitySetupWizard());

    if (!isSuitable) return;

    onButtonClick(currentSubstep);
  };

  return (
    <div>
      {withTitleAndBodyText && (
        <SetupWizardTitleHeader
          classNameFormat={classNameFormat}
          titleFormat={intlTextFormat}
          customTitleId={titleIntlId}
          intlTextFormat={intlTextFormat}
        />
      )}
      {withImage && (
        <div className={`step-${classNameFormat}-image`}>
          <SetupWizardImage
            subStepIndex={currentSubstep ? currentSubstep - 1 : 0}
            stepName={stepName}
            trayType={trayType}
          />
          {withImageCaption && (
            <p className={`step-${classNameFormat}-caption setup-wizard__caption__image`}>
              <FormattedHTMLMessage
                id={`setupWizard.step.${intlTextFormat}.${isHVTrayInstalled ? 'highVolume.' : ''}image1`}
              />
            </p>
          )}
        </div>
      )}
      {showInfo && (
        <div className={`step-${classNameFormat}-info`}>
          <FmlxIcon name="Info" size="sm" customColor="#006AF5" />
          <FormattedHTMLMessage id={`setupWizard.step.${intlTextFormat}.infoText`} />
        </div>
      )}
      {onButtonClick && (
        <div className={`step-${classNameFormat}-button setup-wizard-button`}>
          <div className={`step-${classNameFormat}-button-inner`}>
            <FmlxButton
              variant="outline"
              onClick={handleButtonClick}
              label={<FormattedHTMLMessage id={`setupWizard.step.${intlTextFormat}.firstButton`} />}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...buttonProps}
            />
          </div>
        </div>
      )}
    </div>
  );
}

SetupWizardGeneralStepPage.propTypes = {
  showInfo: PropTypes.bool,
  titleIntlId: PropTypes.string,
  onButtonClick: PropTypes.func,
  buttonProps: PropTypes.object,
  withTitleAndBodyText: PropTypes.bool,
  withImage: PropTypes.bool,
  withImageCaption: PropTypes.bool,
  trayType: PropTypes.any.isRequired,
  commonModalBusinessShowModalUnsupportedTray: PropTypes.func.isRequired,
  commonSetupWizardBusinessGetBodyFormat: PropTypes.func.isRequired,
  // instrumentBusinessIsTrayInstalled: PropTypes.func.isRequired,
  intl: PropTypes.any.isRequired,
};

SetupWizardGeneralStepPage.defaultProps = {
  showInfo: false,
  titleIntlId: null,
  onButtonClick: null,
  withTitleAndBodyText: true,
  withImage: true,
  withImageCaption: true,
  buttonProps: {
    type: 'primary',
    variant: 'outline',
  },
};

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(SetupWizardGeneralStepPage));
